"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasTags = exports.isCallable = exports.isCallableAt = exports.isDateOrNull = exports.isNoShowEntry = exports.isCreatedLogEntry = exports.isServedLogEntry = exports.isCalledLogEntry = exports.isLogEntry = exports.isReservation = exports.isCustomer = exports.isQueueNumber = void 0;
const core_types_1 = require("@dqm/core-types");
function isQueueNumber(queueNumber) {
    if (!(0, core_types_1.isObject)(queueNumber)) {
        return false;
    }
    if (typeof queueNumber.id !== "string") {
        return false;
    }
    if (typeof queueNumber.number !== "string") {
        return false;
    }
    if (!isDateOrNull(queueNumber.callableAfter)) {
        return false;
    }
    if (!isDateOrNull(queueNumber.callableUntil)) {
        return false;
    }
    if (!Array.isArray(queueNumber.tags)) {
        return false;
    }
    if (!Array.isArray(queueNumber.logs)) {
        return false;
    }
    const containsInvalidLogEntries = queueNumber.logs.some((entry) => !isLogEntry(entry));
    if (containsInvalidLogEntries) {
        return false;
    }
    if ("customer" in queueNumber && !isCustomer(queueNumber.customer)) {
        return false;
    }
    if ("reservation" in queueNumber && !isReservation(queueNumber.reservation)) {
        return false;
    }
    return true;
}
exports.isQueueNumber = isQueueNumber;
function isCustomer(customer) {
    if (!(0, core_types_1.isObject)(customer)) {
        return false;
    }
    if ("name" in customer && typeof customer.name !== "string") {
        return false;
    }
    if ("code" in customer && typeof customer.code !== "string") {
        return false;
    }
    if ("phoneNumber" in customer && typeof customer.phoneNumber !== "string") {
        return false;
    }
    return true;
}
exports.isCustomer = isCustomer;
function isReservation(reservation) {
    if (!(0, core_types_1.isObject)(reservation)) {
        return false;
    }
    if ("start" in reservation && reservation.start instanceof Date === false) {
        return false;
    }
    if ("end" in reservation && reservation.end instanceof Date === false) {
        return false;
    }
    if ("summary" in reservation && typeof reservation.summary !== "string") {
        return false;
    }
    if ("tags" in reservation) {
        if (Array.isArray(reservation.tags) === false) {
            return false;
        }
        for (const tag of reservation.tags) {
            if (typeof tag !== "string") {
                return false;
            }
        }
    }
    return true;
}
exports.isReservation = isReservation;
function isLogEntry(entry) {
    if (typeof entry.type !== "string") {
        return false;
    }
    if (!(entry.timestamp instanceof Date)) {
        return false;
    }
    if ("userId" in entry) {
        if (!(typeof entry.userId === "string" || typeof entry.userId === "undefined")) {
            return false;
        }
    }
    return true;
}
exports.isLogEntry = isLogEntry;
function isCalledLogEntry(entry) {
    if (entry.type !== "called") {
        return false;
    }
    return true;
}
exports.isCalledLogEntry = isCalledLogEntry;
function isServedLogEntry(entry) {
    if (entry.type !== "served") {
        return false;
    }
    return true;
}
exports.isServedLogEntry = isServedLogEntry;
function isCreatedLogEntry(entry) {
    if (entry.type !== "created") {
        return false;
    }
    return true;
}
exports.isCreatedLogEntry = isCreatedLogEntry;
function isNoShowEntry(entry) {
    if (entry.type !== "no-show") {
        return false;
    }
    return true;
}
exports.isNoShowEntry = isNoShowEntry;
function isDateOrNull(date) {
    if (date instanceof Date) {
        return true;
    }
    if (date === null) {
        return true;
    }
    return false;
}
exports.isDateOrNull = isDateOrNull;
function isCallableAt(qn, timeNow) {
    if (qn.callableAfter === null) {
        return false;
    }
    if (qn.callableAfter <= timeNow &&
        (qn.callableUntil === null || qn.callableUntil >= timeNow)) {
        return true;
    }
    return false;
}
exports.isCallableAt = isCallableAt;
function isCallable(qn) {
    const timeNow = new Date();
    return isCallableAt(qn, timeNow);
}
exports.isCallable = isCallable;
function hasTags(qn) {
    return !!qn.tags.length;
}
exports.hasTags = hasTags;
//# sourceMappingURL=QueueNumber.js.map